import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las credenciales de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Registro {
  id?: string;
  nombre: string;
  apellidos?: string;
  email: string;
  telefono: string;
  dni?: string;
  fecha_nacimiento?: string;
  direccion?: string;
  codigo_postal?: string;
  ciudad?: string;
  provincia?: string;
  situacion_laboral?: string;
  ingresos_mensuales?: string;
  gastos_mensuales?: string;
  deudas_actuales?: string;
  tipo_vivienda?: string;
  personas_cargo?: number;
  placa?: string;
  usuario?: string;
  servicio?: string;
  mensaje?: string;
  aceptacion_terminos?: boolean;
  aceptacion_privacidad?: boolean;
  created_at?: string;
}
